module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"2016":"Angel Round","2017":"Series A Funding: LOTUS LAKE VENTURES, GOZAP VENTURES","2018":"Series Pre-B Funding: JUN YUE PE FUND"},"zh":{"2016":"天使轮","2017":"A 轮：荷塘创投<small>（前启迪创投）</small>，格致璞\\n","2018":"Pre B 轮：君岳共享"}}')
  delete Component.options._Ctor
}
